import React, { useEffect, useRef, useState, useCallback } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";
import Header from "../../layouts/Header";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import pdfIcon from "../../assets/icons/Pdf icon blur.svg";
import printIcon from "../../assets/icons/Print icon blur.svg";
import duplicateIcon from "../../assets/icons/Duplicate blur.svg";
import refreshIcon from "../../assets/icons/refresh icon.svg";
import LeftArrowCircle from "../../assets/icons/LeftArrowCircle.svg";
import "../Form_Builder_POC/FormBuilderPOC.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FormBuilderPOC3 from "./FormBuilderPOC3";
import CommentBox from "./CommentBox";

import {
  AddForm,
  AddFormSections,
  fetchFormList,
  updateForm,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import * as variables from "./variables";
import "react-form-builder2/dist/app.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { AddSection, EditSection, AddFormName } from "./AddSection";
import { LoadingOutlined } from "@ant-design/icons";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const FormBuilderPOC = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css";
    link.integrity =
      "sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh";
    link.crossOrigin = "anonymous";

    // Append to head
    document.head.appendChild(link);

    // Clean up function to remove link on component unmount
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const dispatch = useDispatch();
  const componentRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const params = useParams();
  const formPOCid = params.id;
  const existingFormContent = useSelector((state) => state.user.formById);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [formNamePopupShow, setFormNamePopupShow] = useState(false);
  const [isTemplate, setIsTemplate] = useState(false);
  const [formName, setFormName] = useState("");
  const [formComponents, setFormComponents] = useState([]);
  const [addSection, setAddSection] = useState(false);
  const [editSection, setEditSection] = useState(false);
  const [sectionName, setSectionName] = useState("");
  const [idCounter, setIdCounter] = useState(0);
  const [currentSection, setCurrentSection] = useState({});
  const [comments, setComments] = useState("");
  const [addFormLoading, setAddFormLoading] = useState(false);
  const [submitHandler, setSubmitHandler] = useState("Add");

  useEffect(() => {
    if (location?.state?.formPopUp) {
      setSubmitHandler("Add");
      setFormNamePopupShow(location?.state?.formPopUp);
    } else if (existingFormContent && existingFormContent?.data) {
      if (existingFormContent?.data?.[0]?.formName) {
        setFormName(existingFormContent?.data?.[0]?.formName);
      }
      if (existingFormContent?.data?.[0]?.comments?.message) {
        setComments(existingFormContent?.data?.[0]?.comments?.message);
      }
      if (existingFormContent?.data?.[0]?.sections) {
        const updatedSections = existingFormContent?.data?.[0]?.sections?.map(
          (section) => {
            const updatedChildren = section?.children?.map((child) => {
              return { ...child, id: Math.ceil(Math.random() * 1000) };
            });
            return {
              ...section,
              iscomplete: section?.iscomplete === 1 ? true : false,
              children: updatedChildren,
              id: Math.ceil(Math.random() * 1000),
            };
          }
        );
        setFormComponents(updatedSections);
      }
      if (existingFormContent?.data?.[0]?.istemplates) {
        setIsTemplate(
          existingFormContent?.data?.[0]?.istemplates === 1 ? true : false
        );
      }
      setSubmitHandler("Update");
    }
  }, [existingFormContent]);

  const handleDownload = async () => {
    window.open(
      `/form/${existingFormContent?.data?.[0]?.formId}/sign`,
      "_blank"
    );
    localStorage.setItem("formComponents", JSON.stringify(formComponents));
    return;

    const element = document.getElementById("form-and-comments");
    if (!element) {
      console.error("Element not found");
      return;
    }

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${formName}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const COMPONENT_TYPES = {
    SECTION: "Section",
    TEXT: "Text Input",
    RADIO: "Radio",
    DROPDOWN: "Dropdown",
    CHECKBOX: "Checkbox",
    HEADER: "Header",
    DATE: "Date Picker",
  };

  const createNewComponent = (componentType, parentId = null) => {
    setIdCounter((prev) => prev + 1);
    const obj = {};
    if (componentType === COMPONENT_TYPES.SECTION) {
      obj["sectionname"] = "New Section";
      obj["iscomplete"] = false;
      obj["children"] = [];
      obj["id"] = `component_${idCounter}`;
      return obj;
    } else if (
      componentType === COMPONENT_TYPES.TEXT ||
      componentType === COMPONENT_TYPES.HEADER ||
      componentType === COMPONENT_TYPES.DATE
    ) {
      obj["id"] = idCounter;
      obj["type"] = componentType;
      obj["title"] = "New Element";
      obj["placeholder"] = "New Element";
      obj["options"] = [];
      return obj;
    } else {
      obj["id"] = idCounter;
      obj["type"] = componentType;
      obj["title"] = "New Element";
      obj["placeholder"] = "New Element";
      obj["options"] = [{ optionName: "Option 1" }, { optionName: "Option 2" }];
      return obj;
    }
  };

  const handleAddSection = () => {
    const newSection = createNewComponent(COMPONENT_TYPES.SECTION);
    setFormComponents((prev) => [
      ...prev,
      { ...newSection, sectionname: sectionName },
    ]);
    setAddSection(false);
    setSectionName("");
  };

  const handleAdd = (parentId, componentType) => {
    console.log(parentId, componentType);
    const newComponent = createNewComponent(componentType, parentId);
    console.log(newComponent);
    setFormComponents((prevComponents) =>
      prevComponents.map((component) =>
        component.id === parentId
          ? {
              ...component,
              children: [...(component.children || []), newComponent],
            }
          : component
      )
    );
  };

  const handleDuplicate = (parentId) => {
    console.log(parentId);
    const newSection = createNewComponent("Section");
    const findSection = formComponents.find(
      (component) => component.id === parentId
    );
    delete findSection.formSectionid;
    setFormComponents((prev) => [
      ...prev,
      { ...findSection, id: newSection.id },
    ]);
  };

  const handleSubmitForm = async () => {
    setAddFormLoading(true);
    const addBody = {
      formName: formName,
      istemplates: isTemplate ? 1 : 0,
      message: comments,
      attachments: "",
      sections: formComponents.map((section) => {
        const updatedSection = { ...section };
        delete updatedSection.id;
        updatedSection["iscomplete"] = updatedSection["iscomplete"] ? 1 : 0;
        if (updatedSection.children.length > 0) {
          const updatedChildrens = updatedSection.children.map(
            (childElement) => {
              const updatedChildren = { ...childElement };
              updatedChildren["elementId"] = updatedChildren.id;
              delete updatedChildren.id;

              return updatedChildren;
            }
          );
          updatedSection["children"] = updatedChildrens;
          return updatedSection;
        } else {
          return updatedSection;
        }
      }),
    };

    const projectDetails =
      localStorage.getItem("projectDetails") &&
      JSON.parse(localStorage.getItem("projectDetails"));

    if (projectDetails && projectDetails.projectId) {
      addBody.projectId = projectDetails.projectId;
      addBody.status = projectDetails.status;
    }

    const updateBody = {
      formId: existingFormContent?.data?.[0]?.formId,
      formName: formName,
      istemplates: isTemplate ? 1 : 0,
      message: comments,
      attachments: "",
      sections: formComponents.map((section) => {
        const updatedSection = { ...section };
        delete updatedSection.id;
        updatedSection["iscomplete"] = updatedSection["iscomplete"] ? 1 : 0;
        if (updatedSection.children.length > 0) {
          const updatedChildrens = updatedSection.children.map(
            (childElement) => {
              const updatedChildren = { ...childElement };
              updatedChildren["elementId"] = `${Math.ceil(
                Math.random() * 1000
              )}`;
              delete updatedChildren.id;

              return updatedChildren;
            }
          );
          updatedSection["children"] = updatedChildrens;
          return updatedSection;
        } else {
          return updatedSection;
        }
      }),
    };
    if (formName) {
      const res = await Promise.resolve(
        dispatch(
          submitHandler === "Add" ? AddForm(addBody) : updateForm(updateBody)
        )
      );
      if (res?.status) {
        setAddFormLoading(false);
        history.goBack();
        localStorage.removeItem("projectDetails");
      }
    }
  };

  const handleEditSection = (parentId) => {
    setEditSection(true);
    const findSection = formComponents.find(
      (component) => component.id === parentId
    );
    setCurrentSection(findSection);
    setSectionName(findSection.sectionname);
  };

  const saveEditSection = () => {
    setEditSection(false);
    setFormComponents((prevComponents) =>
      prevComponents.map((component) =>
        component.id === currentSection.id
          ? {
              ...component,
              sectionname: sectionName,
            }
          : component
      )
    );
    setSectionName("");
  };

  console.log("asc form", existingFormContent);

  return (
    <>
      <section>
        <Header
          leftComponent={
            <div className="d-flex align-items-baseline flex-wrap gap-4">
              <div
                className="settingText"
                onClick={() => {
                  history.push("/settings");
                }}
              >
                {/* Settings */}
                {t("Settings")}
              </div>
              <div
                className="pt-2 d-flex pe-3"
                style={{ background: "#FFFFFF", borderRadius: "10px" }}
              >
                <p className="pt-1 ps-4 pocTxt">
                  {/* {location?.state?.formPopUp && `Forms-Add new |`} {formName} */}
                  {location?.state?.formPopUp && `${t("Forms-Add new")} |`}
                  {formName}
                </p>
              </div>
            </div>
          }
        />
        {formNamePopupShow && (
          <AddFormName
            formName={formName}
            setFormName={setFormName}
            setFormNamePopupShow={setFormNamePopupShow}
            formNamePopupShow={formNamePopupShow}
          />
        )}
        <div
          className="d-flex flex-wrap gap- "
          style={{ justifyContent: "space-between", margin: "0 20px" }}
        >
          <div className="actionHeadTxt pt-2 d-flex align-items-center gap-2">
            <p className="mb-2">
              {/* Save as template */}
              {t("Save as template ")}
            </p>
            <input
              type="checkbox"
              id="asc_purch_Switch"
              className="asc_pursh_Checkbox"
              // disabled={}
              checked={isTemplate}
              onChange={(e) => {
                setIsTemplate((prev) => !prev);
              }}
            />
            <label htmlFor="asc_purch_Switch" className="asc_purch_Toggle">
              {/* <p className=''>ASC</p> */}
            </label>
          </div>

          <div
            className="d-flex align-items-center gap-2 actionHeadTxt"
            onClick={() => {
              setAddSection(true);
              setSectionName("");
            }}
          >
            <img src={duplicateIcon} alt="" width={19} />
            {/* Add Section */}
            {t("Add section ")}
          </div>

          <div
            className="d-flex align-items-center gap-2 actionHeadTxt"
            onClick={() => setFormComponents([])}
          >
            <img src={refreshIcon} alt="" width={19} />
            {/* Reinitiate form */}
            {t("Reinitiate form ")}
          </div>

          {submitHandler === "Update" && (
            <div
              className="d-flex align-items-center gap-2 actionHeadTxt"
              onClick={handleDownload}
            >
              <img src={pdfIcon} alt="" width={19} />
              {/* Execute form */}
              {t("Execute form ")}
            </div>
          )}

          <div className="">
            <button
              className="mb-0 ms-md-aut cancelBtn ascButton"
              onClick={() => {
                history.goBack();
              }}
            >
              {/* Cancel */}
              {t("Cancel ")}
            </button>

            <button
              id="ascPOCButtonDisabled"
              className="addFormPOC ms-2 ascButton"
              disabled={!formComponents.length}
              onClick={() => {
                handleSubmitForm();
              }}
            >
              {addFormLoading ? (
                <LoadingOutlined />
              ) : submitHandler === `Add` ? (
                // "Add"
                t("Add  ")
              ) : (
                // "Update"
                t("Update")
              )}
            </button>
          </div>
        </div>

        <div
          id="form-and-comments"
          style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: 10,
            margin: 20,
            minHeight: "78vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "100%" }}>
            {formComponents.length > 0 && (
              <FormBuilderPOC3
                formComponents={formComponents}
                setFormComponents={setFormComponents}
                handleAdd={handleAdd}
                handleAddSection={handleAddSection}
                onDuplicate={handleDuplicate}
                onEdit={handleEditSection}
              />
            )}
          </div>
          <CommentBox comments={comments} setComments={setComments} />
        </div>
      </section>
      {addSection && (
        <AddSection
          addSection={addSection}
          setAddSection={setAddSection}
          sectionName={sectionName}
          setSectionName={setSectionName}
          handleAddSection={handleAddSection}
        />
      )}
      {editSection && (
        <EditSection
          editSection={editSection}
          setEditSection={setEditSection}
          sectionName={sectionName}
          setSectionName={setSectionName}
          saveEditSection={saveEditSection}
        />
      )}
    </>
  );
};

export default FormBuilderPOC;
